import ssoImg1 from "./../../../../assets/images/licence-img.png"; // Adjust the path as necessary
import pdfIcon from "./../../../../assets/images/pdf.png"; // Adjust the path as necessary


const documents = [
  {
    title: "CARGO AND TOWAGE APPROVAL",
    modified: "2019/08/05 10.35 AM",
    items: [
      "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
      "INS-701-08-03 Container Inspection Form",
      "INS-701-09-01 Towage Inspection",
    ],
  },
  {
    title: "Casualty Report",
    modified: "2019/08/05 10.35 AM",
    items: [
      "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
      "INS-701-08-03 Container Inspection Form",
      "INS-701-09-01 Towage Inspection",
    ],
  },
  {
    title: "Hull Surveys",
    modified: "2019/08/05 10.35 AM",
    items: [
      "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
      "INS-701-08-03 Container Inspection Form",
      "INS-701-09-01 Towage Inspection",
    ],
  },
  {
    title: "INTERNATIONAL OIL POLLUTION AND PREVENTION SURVEY (I.O.P.P)",
    modified: "2019/08/05 10.35 AM",
    items: [
      "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
      "INS-701-08-03 Container Inspection Form",
      "INS-701-09-01 Towage Inspection",
    ],
  },
  {
    title: "LICENSING",
    modified: "2019/08/05 10.35 AM",
    items: [
      "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
      "INS-701-08-03 Container Inspection Form",
      "INS-701-09-01 Towage Inspection",
    ],
  },
  {
    title: "LOAD LINE SURVEY",
    modified: "2019/08/05 10.35 AM",
    items: [
      "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
      "INS-701-08-03 Container Inspection Form",
      "INS-701-09-01 Towage Inspection",
    ],
  },
  {
    title: "SAFETY SURVEYS FOR PASSENGER VESSELS",
    modified: "2019/08/05 10.35 AM",
    items: [
      "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
      "INS-701-08-03 Container Inspection Form",
      "INS-701-09-01 Towage Inspection",
    ],
  },
  {
    title: "Safety Surveys for vessels other than passenger vessels",
    modified: "2019/08/05 10.35 AM",
    items: [
      "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
      "INS-701-08-03 Container Inspection Form",
      "INS-701-09-01 Towage Inspection",
    ],
  },
  {
    title: "SERVICE REQUESTS",
    modified: "2019/08/05 10.35 AM",
    items: [
      "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
      "INS-701-08-03 Container Inspection Form",
      "INS-701-09-01 Towage Inspection",
    ],
  },
  {
    title: "SERVICE STATIONS APPROVALS",
    modified: "2019/08/05 10.35 AM",
    items: [
      "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
      "INS-701-08-03 Container Inspection Form",
      "INS-701-09-01 Towage Inspection",
    ],
  },
  {
    title: "SMALL VESSEL SURVEYS",
    modified: "2019/08/05 10.35 AM",
    items: [
      "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
      "INS-701-08-03 Container Inspection Form",
      "INS-701-09-01 Towage Inspection",
    ],
  },
];

function ShippingSafetyCleanseasTab() {
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        SHIPPING SAFETY 
        <span className="text-orange-ef3e33 font-400"> CLEAN SEAS </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-4 g-lg-0">
        <div className="col-12">
        
          <ul className="strip-ul">
            {documents.map((doc, index) => (
              <li key={index}>
                <div className="row g-4">
                  <div className="col-auto">
                    <img src={pdfIcon} alt="PDF icon" />
                  </div>
                  <div className="col">
                    <div className="row g-4">
                      <div className="col-md">
                        <div className="font-18 font-600">File Name</div>
                        <div className="font-16 font-400">
                          <p className="text-orange-ef3e33 text-uppercase">{doc.title}</p>
                          <ul className="list">
                            {doc.items.map((item, i) => (
                              <li key={i}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <div className="col-md-auto">
                        <div className="font-18 font-600">Modified</div>
                        <div className="font-16 font-400">{doc.modified}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
    
        
      </div>
    </>
  );
}

export default ShippingSafetyCleanseasTab;
